var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaOfferone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5423 24.8673C25.7657 24.8673 30.0001 20.6329 30.0001 15.4095C30.0001 10.1861 25.7657 5.95166 20.5423 5.95166C15.3189 5.95166 11.0845 10.1861 11.0845 15.4095C11.0845 20.6329 15.3189 24.8673 20.5423 24.8673Z",
    fill: "#0FA82E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9052 23.0267C22.8831 23.0267 26.9185 18.9913 26.9185 14.0133C26.9185 9.03541 22.8831 5 17.9052 5C12.9273 5 8.89185 9.03541 8.89185 14.0133C8.89185 18.9913 12.9273 23.0267 17.9052 23.0267Z",
    stroke: "#263238",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56739 9.85704L6.0163 9.85693M0.858398 9.85693H3.92086",
    stroke: "#263238",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69466 17.9043L4.7866 17.8987M0.859375 17.8943L3.01542 17.8967",
    stroke: "#263238",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61057 14.125H3.44653",
    stroke: "#263238",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9818 9.27393H21.2254M14.8742 11.8732H21.1178M19.0171 18.6313L14.7666 14.4724H16.3276C19.7964 14.4724 20.0116 9.27393 16.5427 9.27393",
    stroke: "white",
    strokeWidth: 0.98,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaOfferone);
export default __webpack_public_path__ + "static/media/PAOfferone.5637fc69e0904de6f2a899c4cf490c89.svg";
export { ForwardRef as ReactComponent };